import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LeFAs0ZAAAAACRR7MSPc3CSLNGgsfqYgO5HgxrP" language="en">
      {element}
    </GoogleReCaptchaProvider>
  )
}